import React from 'react'
import { useGameSettings } from './slotGame/slotData'

const JackpotNavbar = () => {

    const { grandJackpotAmount, minorJackpotAmount, majorJackpotAmount, miniJackpotAmount } = useGameSettings()

    return (
        <div className="absolute top-0 w-full h-full grid grid-cols-4 xs:text-xs md:text-md lg:text-lg xl:text-xl 2xl:text-2xl 3xl:text-4xl">
            <div
                className="grid grid-cols-12 bg-center bg-no-repeat bg-cover h-full w-full pb-[3%]"
                style={{
                    backgroundImage: `url(/grand-jackpot-bg.png)`,
                    backgroundSize: "90% 70%",
                }}
            >
                <div className="col-span-5"></div>

                <div className="col-span-7 text-white font-bold flex items-center justify-start">
                    {grandJackpotAmount}
                </div>
            </div>
            <div
                className="grid grid-cols-12 bg-center bg-no-repeat bg-cover h-full w-full pb-[3%]"
                style={{
                    backgroundImage: `url(/minor-jackpot-bg.png)`,
                    backgroundSize: "90% 70%",
                }}
            >
                <div className="col-span-5"></div>

                <div className="col-span-7 text-white font-bold flex items-center justify-start">
                    {minorJackpotAmount}
                </div>
            </div>
            <div
                className="grid grid-cols-12 bg-center bg-no-repeat bg-cover h-full w-full pb-[3%]"
                style={{
                    backgroundImage: `url(/major-jackpot-bg.png)`,
                    backgroundSize: "90% 70%",
                }}
            >
                <div className="col-span-5"></div>

                <div className="col-span-7 text-white font-bold flex items-center justify-start">
                    {majorJackpotAmount}
                </div>
            </div>
            <div
                className="grid grid-cols-12 bg-center bg-no-repeat bg-cover h-full w-full pb-[3%]"
                style={{
                    backgroundImage: `url(/mini-jackpot-bg.png)`,
                    backgroundSize: "90% 70%",
                }}
            >
                <div className="col-span-4"></div>

                <div className="col-span-8 text-white font-bold flex items-center justify-start">
                    {miniJackpotAmount}
                </div>
            </div>
        </div>
    )
}

export default JackpotNavbar